import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableFooter,
  TablePagination,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  shimmer: {
    animation: "$shimmer 1.5s infinite",
    background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
    backgroundSize: "200% 100%",
    borderRadius: theme.shape.borderRadius,
  },
  cell: {
    padding: theme.spacing(1, 2),
  },
  shimmerText: {
    height: "1em",
    width: "100%",
  },
  shimmerIcon: {
    height: "24px",
    width: "24px",
    borderRadius: "50%",
    margin: "0 auto",
  },
  "@keyframes shimmer": {
    "0%": {
      backgroundPosition: "200% 0",
    },
    "100%": {
      backgroundPosition: "-200% 0",
    },
  },
}));

const ReportTableShimmer = () => {
  const classes = useStyles();
  const rows = 10; // Number of shimmer rows to display

  return (
    <TableContainer component={(props) => <Paper {...props} elevation={0} />}>
      <Table aria-label="report table shimmer" size="small">
        <TableHead>
          <TableRow>
            {["Index", "Report Name", "File Size", "download"].map((header) => (
              <TableCell
                key={header}
                className={classes.cell}
                align={header === "Download" ? "center" : "left"}
              >
                <div
                  className={`${classes.shimmer} ${classes.shimmerText}`}
                  style={{ width: header === "Index" ? "30px" : "auto" }}
                />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(rows)].map((_, index) => (
            <TableRow key={index}>
              <TableCell className={classes.cell}>
                <div
                  className={`${classes.shimmer} ${classes.shimmerText}`}
                  style={{ width: "30px" }}
                />
              </TableCell>
              <TableCell className={classes.cell}>
                <div
                  className={`${classes.shimmer} ${classes.shimmerText}`}
                  style={{ width: "80%" }}
                />
              </TableCell>
              <TableCell className={classes.cell}>
                <div
                  className={`${classes.shimmer} ${classes.shimmerText}`}
                  style={{ width: "60px" }}
                />
              </TableCell>
              <TableCell className={classes.cell} align="center">
                <div className={`${classes.shimmer} ${classes.shimmerIcon}`} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[]}
              count={-1}
              rowsPerPage={10}
              page={0}
              onChangePage={() => {}}
              onChangeRowsPerPage={() => {}}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default ReportTableShimmer;
